import Swiper, { Navigation, Pagination, Scrollbar, Autoplay } from 'swiper';

Swiper.use([Navigation, Pagination, Scrollbar, Autoplay]);

/**
 * Слайдер отзывов (Текстовый блок с отзывами на определенную тему.
 * Серый фон, белая карточка.
 * @constructor
 */
export default function Video() {
  // eslint-disable-next-line no-new
  new Swiper('.reviews-slider_inner .swiper', {
    direction: 'horizontal',
    rewind: true,
    spaceBetween: 20,
    autoHeight: true,
    draggable: true,
    preloadImages: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    freeMode: {
      enabled: false,
      sticky: false,
    },
    pagination: {
      el: '.reviews-slider_inner .swiper .swiper-pagination',
      clickable: true,
      renderBullet: (index, className) => `<div class="pagination-dot ${className}"></div>`,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
    },
    autoplay: {
      enabled: true,
      delay: 6000,
      disableOnInteraction: false,
    },
  });
}
